import { render, staticRenderFns } from "./SimulationDataPointsTable.vue?vue&type=template&id=3a9c50b8&scoped=true&"
import script from "./SimulationDataPointsTable.vue?vue&type=script&lang=js&"
export * from "./SimulationDataPointsTable.vue?vue&type=script&lang=js&"
import style0 from "./SimulationDataPointsTable.vue?vue&type=style&index=0&id=3a9c50b8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c50b8",
  null
  
)

export default component.exports